<template>
<div class="card" id="device">
    <div class="card-header d-flex align-items-center justify-content-between device-title">
        <h3>Peon List</h3> 
    </div> 
    <div class="card-body" style="padding: 1.25rem;">
        <button type="button" class="btn btn-success " @click="openModal()">Device 추가</button>
        <table class="table table-striped table-bordered table-hover">
            <thead>
                <tr class="text-center device-table-header">
                    <th>Type</th>
                    <th>Device ID</th>
                    <th>Alias</th>
                    <th>Assignee</th>
                    <th>Modify</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="device in deviceList" v-bind:key="device.deviceId">                  
                    <td class="text-center">
                        <b-form-group v-slot="{ ariaDescribedby }">
                            <b-form-radio-group id="btn-radios-1" v-model="device.devType" :options="devTypes"
                            :aria-describedby="ariaDescribedby" name="radios-btn-default" button-variant="outline-secondary" buttons @change="updateDeviceDevType(device.deviceId, $event)"></b-form-radio-group>
                        </b-form-group>
                    </td>
                    <td>{{ device.deviceId }}</td>
                    <td>{{ device.alias }}</td>
                    <td><span v-for="assignee in device.assignees" :key="assignee.userId" class="multiselect__tag" style="padding-right: 10px;">{{ assignee.userName }}</span></td>
                    <td class="text-center">
                        <b-button variant="primary" @click="openModal(device)">Modify</b-button>
                        <button type="button" class="btn btn-danger" @click="deleteDevice(device.deviceId)">Delete</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div> <!--card-body-->
    <!--Message Modal-->
    <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary" ok-title="Close">
        <p class="my-4 text-center">{{ msgContent }}</p>
    </b-modal>
    <b-modal id="registerModal" centered v-model="modalShow" title="Device 등록/수정" @ok="registerDevice">
        <b-container fluid id="register-modal-body">
            <b-form>
                <b-form-group label-cols="4" label-cols-lg="3" label="Device ID" label-for="input-sm">
                    <b-form-input class="form-control" v-model="deviceId" invalid-feedback="Device ID is required" :state="deviceId.length == 16"></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="3" label="Alias" label-for="input-sm">
                    <b-form-input class="form-control" v-model="alias" invalid-feedback="Alias is required" required></b-form-input>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="3" label="Type" label-for="input-sm">
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group id="btn-radios-1" v-model="devType" :options="devTypes" size="sm"
                                            :aria-describedby="ariaDescribedby" name="radios-btn-default" button-variant="outline-secondary" buttons></b-form-radio-group>
                    </b-form-group>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="3" label="SMS Alerts" label-for="input-sm">
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group id="btn-radios-2" v-model="checked" :options="checkTypes" size="sm"
                                            :aria-describedby="ariaDescribedby" name="radios-btn-default" button-variant="outline-secondary" buttons></b-form-radio-group>
                    </b-form-group>
                </b-form-group>
                <b-form-group label-cols="4" label-cols-lg="3" label="Assignees" label-for="input-sm">
                    <multiselect v-model="assignees" 
                            :options="operatorList" 
                            track-by="userId" 
                            label="userName" 
                            :multiple="true"
                            :close-on-select="false"
                            placeholder=""></multiselect>
                </b-form-group>
            </b-form>
        </b-container>
    </b-modal>
</div> <!--card-->   
<!--device 등록 Modal-->

</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { faGrinTongueSquint } from '@fortawesome/free-solid-svg-icons';
import Multiselect from 'vue-multiselect'
export default {
    name: 'Device',
    components: { Multiselect },
    data() {
        return {
            deviceId: '',
            alias: '',
            submitted: false,
            loading: false, 
            msgStatus: '',
            msgContent: '',
            devType: 'normal',
            devTypes: [
              { value: 'normal', text: '일반' },
              { value: 'dev', text: '개발' }
            ],
            modalShow: false,
            assignees: [],
            checked: true,
            checkTypes: [
              { value: true, text: 'ON' },
              { value: false, text: 'OFF' }
            ],
            new: true,
        }
    },
    watch: {
        assignees: function(newVal, oldVal) {
            console.log('Current assignees:', newVal);
        }
    },
    computed: {
        deviceList: function() {
            return this.$store.getters.getPeonList;
        },
        operatorList: function() {
            return this.$store.getters.getUserList.filter(user => user.roleCode.includes('Operator'));
        },
    },
    methods: {
        async updateDeviceDevType(deviceId, devType) {
            this.loading = true;

            var iniDevType = '';
            var params = {
                'deviceId': deviceId
            };

            await axios.get('device/retrieveDevice', {
                params: params,
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                iniDevType = (response.data.body.devType == 'dev' ? 'dev' : 'normal');
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.loading = false;
            });

            // 변경사항 없는 경우
            if(devType == iniDevType) {
                return;
            }

            this.$bvModal.msgBoxConfirm('디바이스를 ' + (devType ==  'dev' ? '개발' : '일반') + '용으로 변경하시겠습니까?', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'YES',
                cancelTitle: 'NO',
                headerClass: 'detail-header',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(async value => {            
                if(value) {
                    // Confirm
                    this.loading = true;
                    await axios.post('device/updateDeviceDevType', {'deviceId': deviceId, 'devType' : (devType=='normal'? 'normal' : 'dev')}, {
                        headers: {
                            'Accept': 'application/json',
                            'Authorization': window.accessToken()
                        }
                    });
                }

            }).catch(response => {
                // An error occurred
                this.msgStatus = response.status;
                this.msgContent = response.message;
                
                this.$bvModal.show('messageModal');

            }).finally(() => {
                this.$store.dispatch('retrievePeonList'); 
                this.loading = false;

            });
        },
        registerDevice(bvModalEvent) {
            bvModalEvent.preventDefault();
            this.submitted = true;
            
            let url = "";
            if(this.new) url = 'registerDevice';
            else url = 'updateDevice';

            this.assignees.forEach(assignee => {
                assignee.deviceId = this.deviceId;
                assignee.active = this.checked;
            });
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true;
                   
                    this.$store.dispatch(url, {'deviceId': this.deviceId, 
                                                            'alias': this.alias, 
                                                            'devType': this.devType, 
                                                            'assignees': this.assignees})
                    .then(response => {
                        this.msgStatus = response.status;
                        if(this.new) this.msgContent = 'Device 정보가 등록되었습니다.';
                        else this.msgContent = 'Device 정보가 수정되었습니다.';
                        this.$bvModal.show('messageModal');
                        
                        this.resetData();
                        
                        this.submitted = false;
                        this.modalShow = false;

                    }).catch(response => {
                        this.msgStatus = response.status;
                        this.msgContent = response.message;
                        
                        this.$bvModal.show('messageModal');

                    }).finally(() => {
                        this.loading = false;
                        
                    });
                }
            });
        },
        deleteDevice(deviceId) {
            this.$store.dispatch('deleteDevice', deviceId);
        }, 
        hideModal() {
          this.$refs['messageModal'].hide();
        },
        openModal(device) {
            if(device) {
                this.deviceId = device.deviceId;
                this.alias = device.alias;
                this.devType = device.devType;
                // userList에서 id가 일치하는 객체 list 반환
                this.assignees = device.assignees;
                this.checked = this.assignees ? this.assignees[0].active : true;
                this.new = false;
            } else {
                this.new = true;
                this.resetData();
            }
            this.modalShow = !this.modalShow;
        },
        resetData() {
            this.deviceId = '';
            this.alias = '';
            this.devType = 'normal';
            this.assignees = [];
            this.checked = true;
        }
    },
    created() {
        this.$store.dispatch('retrievePeonList'); 
        this.$store.dispatch('retrieveUserList');
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-outline-secondary:not(:disabled):not(.disabled).active {
    color: #fff !important;
    background-color: #67c23a !important;
    border-color: #67c23a !important;
}
#registerModal .form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px) !important;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem !important;
}
#register-modal-body {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
}
</style>
